"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.Request = exports.Method = void 0;
var util_1 = require("../../util");
var base_1 = require("../../base");
Object.defineProperty(exports, "Method", { enumerable: true, get: function () { return base_1.Method; } });
Object.defineProperty(exports, "ContentType", { enumerable: true, get: function () { return base_1.ContentType; } });
// XHR 超时时间
var xhrMaxTimeOut = 30000;
var Request = /** @class */ (function () {
    function Request() {
    }
    Request.prototype.sendCommonRequest = function (parameter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var _a;
                        try {
                            var error_1;
                            var xhr_1 = new XMLHttpRequest();
                            xhr_1.onreadystatechange = function () {
                                if (xhr_1.readyState === XMLHttpRequest.DONE) {
                                    var data = '';
                                    if (xhr_1.status === 200) {
                                        data = xhr_1.responseText;
                                    }
                                    else {
                                        error_1 = new base_1.HttpError('StatusError', xhr_1.status);
                                    }
                                    resolve(new base_1.Result(error_1, data));
                                }
                            };
                            try {
                                xhr_1.timeout = (_a = parameter.timeout) !== null && _a !== void 0 ? _a : xhrMaxTimeOut;
                            }
                            catch (e) {
                                util_1.ConnectionLog.error("request error message: " + (e === null || e === void 0 ? void 0 : e.message));
                            }
                            xhr_1.ontimeout = function () {
                                error_1 = new Error('TimeOutError');
                                resolve(new base_1.Result(error_1));
                            };
                            xhr_1.open(parameter.method, parameter.url);
                            if (parameter.contentType === base_1.ContentType.JSON) {
                                xhr_1.setRequestHeader('content-type', base_1.ContentTypeValue.JSON);
                                xhr_1.setRequestHeader('content-encoding', 'gzip');
                            }
                            else {
                                xhr_1.setRequestHeader('content-type', base_1.ContentTypeValue.FORM);
                            }
                            xhr_1.send(parameter.body);
                        }
                        catch (error) {
                            resolve(new base_1.Result(error));
                        }
                    })];
            });
        });
    };
    return Request;
}());
exports.Request = Request;
